import { PlatformLocation } from '@angular/common';

export function getApiBasePath(platformLocation: PlatformLocation): string {
    return window.location.origin + '/user/api/0.exp';
}
